module.exports = __webpack_public_path__ + "static/media/pc_icon_right_normal.06dd04e9.svg";